import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import NavAdhocMain from './NavAdhocMain';
import NavAdhocSub from './NavAdhocSub';
import AdhocTable from './AdhocTable';
import AdhocCreateModal from './AdhocCreateModal';
import { loadSupport, getAppInfo, loadAdhocControlValues, 
  updateRelatedTaskList, getAdhocRequesters, getUserInfo } from './thunks';
import 'bootstrap/dist/css/bootstrap.min.css';
import './AdhocHome.css';

const AdhocHome = ({ startLoadSupport, startGetAppInfo, startLoadAdhocControlValues, 
  startUpdateRelatedTaskList, startGetAdhocRequesters, startGetUserInfo }) => {
    
  let paramsText = window.location && window.location.search;
  paramsText = paramsText && paramsText.substring(1);
  let params = {};
  try {
    params = JSON.parse('{"' + decodeURI(paramsText).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');
  } catch(e) {
    console.log('error in parsing params');
  }
  console.log('AppHome params:', params);
  startGetUserInfo({ userId:params.user });
  
  useEffect(() => {
    startGetAppInfo();
    startLoadSupport();
    startLoadAdhocControlValues();
    startUpdateRelatedTaskList();
    startGetAdhocRequesters();
  }, 
  // eslint-disable-next-line
  []);
  
  const content = (
    <div className="AdhocContainer">
      <NavAdhocMain />
      <NavAdhocSub />
      <Container fluid>
        <AdhocTable />
        <AdhocCreateModal />
     </Container>
  </div>
  );
  return content;
};

const mapState = state => ({
})

const mapDispatch = dispatch => ({
  startGetAppInfo: (data) => dispatch(getAppInfo(data)),
  startLoadSupport: (data) => dispatch(loadSupport(data)),
  startUpdateRelatedTaskList: (data) => dispatch(updateRelatedTaskList(data)),
  startLoadAdhocControlValues: (data) => dispatch(loadAdhocControlValues(data)),
  startGetAdhocRequesters: (data) => dispatch(getAdhocRequesters(data)),
  startGetUserInfo: (data) => dispatch(getUserInfo(data)),
})

export default connect(mapState, mapDispatch)(AdhocHome);
